import React from 'react';
import { Zlogo } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box, useTheme } from '@mui/material';

export const ZscalerLogo = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        ...flex.center,
        aspectRatio: '1 / 1',
        backgroundColor: theme => theme.palette.colors.neutrals[300],
        borderRadius: '100%',
        flexShrink: 0,
        height: 24,
        width: 24,
      }}>
      <Zlogo style={{ ...iconSize(16), color: theme.palette.colors.primary[500] }} />
    </Box>
  );
};
